<template>
  <div class="columns-container">
    <div id="importerOptionsSection" class="column">
      <quote-list-block>
        <template #header>
          <div class="title">
            {{ i18n.t('/change-order/configuration/control-codes') }}
          </div>
        </template>
        <template #body>
          <configuration-feature
            v-for="feature in originalOptions"
            :key="feature.Id"
            :can-detect-feature-change="true"
            :original-features="editableOptions"
            :feature="feature"
          />
        </template>
      </quote-list-block>
    </div>
    <div class="column">
      <quote-list-block>
        <template #header>
          <div class="title">
            {{ i18n.t('/change-order/configuration/control-codes') }}
          </div>
          <div
            v-if="isChangeButtonVisible && canChangeOption.Allowed"
            class="edit-dialog"
            @click="showChangeOptionsDialog"
          >
            <i class="fa-solid fa-pencil"></i>
          </div>
          <div
            v-if="isChangeButtonVisible && !canChangeOption.Allowed && !!canChangeOption.Reason"
            class="edit-dialog"
            :title="canChangeOption.Reason"
          >
            <i class="fa-solid fa-lock"></i>
          </div>
        </template>
        <template #body>
          <configuration-feature
            v-for="feature in editableOptions"
            :key="feature.Id"
            :can-detect-feature-change="true"
            :original-features="originalOptions"
            :feature="feature"
          />
        </template>
      </quote-list-block>
    </div>
    <multiple-feature-change-dialog
      v-if="showOptionsChangeDialog"
      :title="i18n.t('/change-order/configuration/change-options')"
      :available-items="availableOptions"
      :selected-items="changedOptions"
      :show-options-search-input="true"
      @close="showOptionsChangeDialog = false"
      @confirm="confirmOptionsChange"
    />
  </div>
</template>

<script>
import QuoteListBlock from '@/components/generic/presentational/molecules/quoteListBlock/QuoteListBlock.vue'
import ConfigurationFeature from '@/components/changeOrder/presentational/organisms/configurationFeature/ConfigurationFeature.vue'
import MultipleFeatureChangeDialog from '@/components/changeOrder/presentational/organisms/multipleFeatureChangeDialog/multipleFeatureChangeDialog.vue'
import { mapGetters } from 'vuex'
import ChangeOrderStatus from '@/helpers/enums/changeOrderStatus'

export default {
  components: {
    MultipleFeatureChangeDialog,
    ConfigurationFeature,
    QuoteListBlock,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showOptionsChangeDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      changeOrder: 'changeOrder/get',
      dealerSettings: 'user/dealerSettings',
    }),
    originalOptions() {
      return this.optionsAndAccessoriesWithoutInterior(
        this.changeOrder.CarConfiguration.OriginalOptions
      )
    },
    editableOptions() {
      return this.optionsAndAccessoriesWithoutInterior(
        this.changeOrder.CarConfiguration.ChangedOptions
      )
    },
    changedOptions() {
      return this.optionsAndAccessoriesWithoutInterior(
        this.changeOrder.CarConfiguration.ChangedOptions
      )
    },
    availableOptions() {
      let availableOptions = this.changeOrder.CarConfiguration.AvailableOptions
      let filteredOptions = availableOptions.filter((option) => this.isSteeringCode(option))

      return this.sortOptionsBy(filteredOptions, 'shortId')
    },
    isChangeButtonVisible() {
      return this.dealerSettings.isImporter
    },
    canChangeOption() {
      if (!this.isChangeButtonVisible) {
        return {
          Allowed: false,
        }
      }

      if (
        this.changeOrder.MainOrderStatus === ChangeOrderStatus.submitted ||
        this.changeOrder.MainOrderStatus === ChangeOrderStatus.archived
      ) {
        return {
          Allowed: false,
          Reason: 'Order has been submitted or deleted',
        }
      }

      if (this.changeOrder.CarConfiguration.HasUnknownOkapiModel) {
        return {
          Allowed: false,
          Reason:
            'Het is voor dit voertuig niet mogelijk om configuratiewijzigingen door te voeren.',
        }
      }

      return this.changeOrder.Permissions.CanChangeImporterOptions
    },
  },
  methods: {
    optionsAndAccessoriesWithoutInterior(options) {
      return options?.filter((option) => this.isSteeringCode(option)) || []
    },
    isSteeringCode(option) {
      return option.Type === 'STEERING_CODE'
    },
    showChangeOptionsDialog() {
      this.showOptionsChangeDialog = true
    },
    confirmOptionsChange(changedOptions) {
      let interiorOptions = this.changeOrder.CarConfiguration.ChangedOptions.filter(
        (option) => !this.isSteeringCode(option)
      )
      this.changeOrder.CarConfiguration.ChangedOptions = interiorOptions.concat(changedOptions)

      this.$store.commit('changeOrder/setCarConfigurationStatus')
      this.showOptionsChangeDialog = false
    },
    sortOptionsBy(options, key) {
      return options.sort((a, b) => {
        let valA = a[key]
        let valB = b[key]
        if (valA < valB) {
          return -1
        }
        if (valA > valB) {
          return 1
        }
        return 0
      })
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.row) {
  grid-template-columns: auto 4em 8em 1em 2em;
  grid-template-areas: 'title code price-incl info-icon edit-dialog';
}

.info-icon {
  cursor: pointer;
}

.edit-dialog {
  cursor: pointer;
}
.columns-container {
  display: flex;
  justify-content: space-between; /* Distribute columns evenly */
}

.column {
  flex: 1;
  margin: 0 10px;
}
</style>
